import { LockablePropertyStripLayout } from '../../canvas/properties/LockablePropertyStripLayout';
import { lockAndMoreLayout } from '../../canvas/properties/TextPropertyStripParts';
import { SmartBox } from './SmartBox';

export const SmartBoxPropertyLayout = LockablePropertyStripLayout<SmartBox>((d, s, o, w, a) => [
    //
    // Edit Text
    // w.createPopout({
    //     name: 'edit',
    //     image: 'deqo://icons/hero/calculator',
    //     text: 'Edit Compute',
    //     ui: ComputeWidget(a.first()),
    // }),
    //
    // Background
    w.createColorSelector({
        allowNull: true,
        groups: true,
        autoSelect: true,
        value: a.get('background'),
        text: 'Background Color',
        onSelect() {
            o.update(() => a.set('background', this.value!));
        }
    }),
    ...lockAndMoreLayout(d, s, o, w, a),
]);
